export const timings = {
  start: 3,
  intro: true,
  add: 1,
  after: 5,
}
